import React from 'react'

// Components
import CloseIcon from '@mui/icons-material/Close';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import CheckIcon from '@mui/icons-material/Check';
import { SaveAltRounded } from '@mui/icons-material';
import { IconButton } from '@mui/material';
// Component Date
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/es';
import dayjs from "dayjs";

import { FormHelperText } from '@mui/material';

// Styles
import { Label, ContainerEpsArl, ContainerInput, ContainerGroup, ContainerContent, ContainerBox, ContainerChecks, CustomCheckbox, ContainerCertificates, UploadButton, ContainerUpload, ContainerElectricalTechnician, ContainerElectricalTechnicianFields } from './styles'

// Utils
import { useTranslation } from 'react-i18next'
import { SelectInput } from '../../../SelectInput'

// Link
import Link from '@mui/material/Link';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { ColorsContext } from '../../../../Context/ColorsContext';
import { CompanyWorkerApi } from '../../../../services/CompanyWorkerApi';
import axios from 'axios';
import Router from "../../../../router";
import { ContainerInputsDate, CustomFormLabel, CustomTextField } from '../../../../pages/styles';

const mapeoStatusIcons = {
    active: {
        color: '#4CAF50',
        icon: CheckIcon,
    },
    loading: {
        color: '#FFB74D',
        icon: HourglassTopIcon,
    },
    error: {
        color: '#E57373',
        icon: CloseIcon,
    },
};


function renderIcon(status) {
    const statusConfig = mapeoStatusIcons[status] || {};
    const IconComponent = statusConfig.icon || null;
    const color = statusConfig.color || 'gray';

    if (!IconComponent) return null;

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: color,
                borderRadius: '50%',
                width: '24px',
                height: '24px',
            }}
        >
            <IconComponent style={{ color: 'white', fontSize: '16px' }} />
        </div>
    );
}


export const CompanyWorkerForms = ({
    isEdit, form, errors, disabled, specialties, assignations, handleChange, handleChangeCertificates, arrayEps, arrayArl,
    isRetieTechnicalCertificate, arrayRoleElectricalLevels, handleChangeFile
}) => {
    const companyWorkerApi = new CompanyWorkerApi();
    const { t } = useTranslation();
    const { colors } = React.useContext(ColorsContext);
    const [fileData, setFileData] = React.useState([]);


    async function downloadFile(workerId, isEps) {
        const resp = await axios.get(
            `${Router.apiBaseUrl}${Router.apiCompanyWorkerFiles}`,
            { params: { id: workerId, isEps }, responseType: "blob" }
        );

        const cd = resp.headers["content-disposition"] || "";
        const match = cd.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
        const fileName = match ? decodeURIComponent(match[1]) : (isEps ? "eps.pdf" : "arl.pdf");

        const url = window.URL.createObjectURL(resp.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    }



    return (
        <ContainerBox>
            <ContainerContent>
                <ContainerGroup>
                    <ContainerInput sx={{ width: { xs: '100%', sm: '25%' } }}>
                        <CustomFormLabel>{t('worker.table.identification')}:</CustomFormLabel>
                        <CustomTextField
                            type='number'
                            value={form.identification}
                            size="small"
                            onChange={e => {
                                const value = e.target.value.replace(/\D/g, '');
                                handleChange({ target: { value } }, 'identification');
                            }}
                            onInput={e => e.target.value = e.target.value.replace(/\D/g, '')}
                            error={!(!errors?.identification.error)}
                            helperText={errors?.identification.error}
                            style={{ width: '100%' }}
                            disabled={disabled}
                            required
                        />
                    </ContainerInput>
                    <ContainerInput sx={{ width: { xs: '100%', sm: '24%' } }}>
                        <CustomFormLabel>{t('worker.table.dateIssue')}:</CustomFormLabel>
                        <ContainerInputsDate errorstart={errors?.identificationDate.error} >
                            <LocalizationProvider dateAdapter={AdapterDayjs} id='Loclization Date'>
                                <DemoContainer components={['DatePicker']} id='Demo Container'>
                                    <DatePicker
                                        label=''
                                        value={dayjs(form.identificationDate)}
                                        // minDate={dayjs('2020-03-20')}
                                        maxDate={dayjs()}
                                        onChange={e => handleChange(e || '', "identificationDate", "date")}
                                        slotProps={{ textField: { size: 'small', error: errors?.identificationDate.error } }}
                                        format="DD/MM/YYYY"
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                        </ContainerInputsDate>
                        {errors?.identificationDate?.error && (
                            <FormHelperText style={{ marginLeft: '12px' }} error={true}>{errors.identificationDate.error}</FormHelperText>
                        )}
                    </ContainerInput>
                    <ContainerInput sx={{ width: { xs: '100%', sm: '50%' } }}>
                        <CustomFormLabel>{t('worker.table.email')}:</CustomFormLabel>
                        <CustomTextField
                            type='text'
                            value={form.email}
                            size="small"
                            onChange={e => handleChange(e, 'email')}
                            error={!(!errors?.email.error)}
                            helperText={errors?.email.error}
                            style={{ width: '100%' }}
                            disabled={disabled}
                            required
                        />
                    </ContainerInput>
                </ContainerGroup>

                <ContainerGroup>
                    <ContainerInput>
                        <CustomFormLabel>{t('worker.table.name')}:</CustomFormLabel>
                        <CustomTextField
                            value={form.name}
                            size="small"
                            onChange={e => handleChange(e, 'name')}
                            error={!(!errors?.name.error)}
                            helperText={errors?.name.error}
                            style={{ width: '100%' }}
                            disabled={disabled}
                            required
                        />
                    </ContainerInput>
                    <ContainerInput>
                        <CustomFormLabel>{t('worker.table.lastName')}:</CustomFormLabel>
                        <CustomTextField
                            value={form.lastName}
                            size="small"
                            onChange={e => handleChange(e, 'lastName')}
                            error={!(!errors?.lastName.error)}
                            helperText={errors?.lastName.error}
                            style={{ width: '100%' }}
                            disabled={disabled}
                            required
                        />
                    </ContainerInput>
                </ContainerGroup>

                <ContainerGroup>

                    <ContainerInput>
                        <ContainerEpsArl>
                            <CustomFormLabel>{t('worker.table.eps')}:</CustomFormLabel>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '2px' }}>

                                <SelectInput
                                    placeholder=""
                                    onChange={(e) => handleChange(e, 'eps', 'select')}
                                    value={form.eps}
                                    options={arrayEps}
                                    keyValue="name"
                                    sx={{ width: '25%' }}
                                    size="small"
                                    disabled={disabled}
                                />
                                {renderIcon(form?.epsStatus)}
                            </div>

                            <ContainerUpload>
                                <UploadButton component="label" startIcon={<CloudUploadIcon />} sx={{ color: colors.buttonActionColor }}>
                                    <input type="file" accept=".pdf" hidden onChange={e => handleChangeFile(e, 'eps')} /> {t('worker.table.attachCertificate')}
                                </UploadButton>
                                <span>{form.fileEpsName.split(/[/\\]/).pop()}</span>

                                {form.id && (
                                    <IconButton onClick={() => downloadFile(form.id, true)}>
                                        <SaveAltRounded sx={{ color: colors.buttonActionColor }} />
                                    </IconButton>
                                )}

                            </ContainerUpload>

                        </ContainerEpsArl>
                        {errors?.fileEpsName?.error && (
                            <FormHelperText style={{ marginLeft: '12px' }} error={true}>{errors.fileEpsName.error}</FormHelperText>
                        )}
                    </ContainerInput>


                    <ContainerInput>
                        <ContainerEpsArl>

                            <CustomFormLabel>{t('worker.table.arl')}:</CustomFormLabel>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '2px' }}>
                                <SelectInput
                                    placeholder=""
                                    onChange={(e) => handleChange(e, 'arl', 'select')}
                                    value={form.arl}
                                    options={arrayArl}
                                    keyValue="name"
                                    sx={{ width: '25%' }}
                                    size="small"
                                    disabled={disabled}
                                />
                                {renderIcon(form?.arlStatus)}
                            </div>

                            <ContainerUpload>
                                <UploadButton component="label" startIcon={<CloudUploadIcon />} sx={{ color: colors.buttonActionColor }}>
                                    <input type="file" accept=".pdf" hidden onChange={e => handleChangeFile(e, 'arl')} /> {t('worker.table.attachCertificate')}
                                </UploadButton>
                                <span>{form.fileArlName.split(/[/\\]/).pop()}</span>

                                {form.id && (
                                    <IconButton onClick={() => downloadFile(form.id, false)}>
                                        <SaveAltRounded sx={{ color: colors.buttonActionColor }} />
                                    </IconButton>
                                )}
                            </ContainerUpload>

                        </ContainerEpsArl>
                        {errors?.fileArlName?.error && (
                            <FormHelperText style={{ marginLeft: '12px' }} error={true}>{errors.fileArlName.error}</FormHelperText>
                        )}

                    </ContainerInput>

                </ContainerGroup>

                <ContainerGroup>
                    <ContainerInput>
                        <CustomFormLabel>{t('worker.table.emergencyContactFullName')}:</CustomFormLabel>
                        <CustomTextField
                            value={form.emergencyContactFullName}
                            size="small"
                            onChange={e => {
                                const value = e.target.value;
                                if (/^[a-zA-ZÑñ\s]*$/.test(value)) {
                                    handleChange(e, 'emergencyContactFullName');
                                }
                            }}
                            error={!(!errors?.emergencyContactFullName.error)}
                            helperText={errors?.emergencyContactFullName.error}
                            style={{ width: '100%' }}
                            disabled={disabled}
                            required
                        />
                    </ContainerInput>
                    <ContainerInput>
                        <CustomFormLabel>{t('worker.table.emergencyContactPhone')}:</CustomFormLabel>
                        <CustomTextField
                            value={form.emergencyContactPhone}
                            size="small"
                            onChange={e => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) {
                                    handleChange(e, 'emergencyContactPhone');
                                }
                            }}
                            error={!(!errors?.emergencyContactPhone.error)}
                            helperText={errors?.emergencyContactPhone.error}
                            style={{ width: '100%' }}
                            disabled={disabled}
                            required
                        />
                    </ContainerInput>

                </ContainerGroup>

                <ContainerGroup>
                    {form.certificates.map((certificate) => (
                        <ContainerCertificates key={certificate.id}>
                            <CustomFormLabel>{certificate?.name ?? ""}:</CustomFormLabel>
                            <SelectInput
                                placeholder=""
                                onChange={(e) => handleChangeCertificates(e, certificate.id)}
                                value={certificate.selectedOptions}
                                options={certificate.options}
                                keyValue="name"
                                sx={{ width: '25%' }}
                                size="small"
                                limitTags={5}
                                disableCloseOnSelect={false}
                                multiple={true}
                                disabled={disabled}
                            />
                        </ContainerCertificates>
                    ))}
                </ContainerGroup>

                {/* Si selecciona certificado Retie, rol técnico */}
                {isRetieTechnicalCertificate &&
                    <ContainerElectricalTechnician>
                        <CustomFormLabel>{t('worker.table.electricalTechnician')}:</CustomFormLabel>
                        <ContainerElectricalTechnicianFields>
                            <ContainerCertificates sx={{ width: '50%' }}>
                                <CustomFormLabel>{t('worker.table.class')}:</CustomFormLabel>
                                <SelectInput
                                    placeholder=""
                                    onChange={(e) => handleChange(e, 'certificateRoleElectricalLevels', 'select')}
                                    value={form.certificateRoleElectricalLevels}
                                    options={arrayRoleElectricalLevels}
                                    keyValue="name"
                                    width='100%'
                                    size="small"
                                    limitTags={5}
                                    disableCloseOnSelect={false}
                                    multiple={true}
                                    error={errors?.certificateRoleElectricalLevels.error}
                                    disabled={disabled}
                                />
                            </ContainerCertificates>

                            <ContainerCertificates sx={{ width: '50%' }}>
                                <CustomFormLabel>{t('worker.table.loadPdfFile')}:</CustomFormLabel>
                                <ContainerUpload>
                                    <UploadButton component="label" startIcon={<CloudUploadIcon />} sx={{ color: colors.buttonActionColor }}>
                                        <input type="file" accept=".pdf" hidden onChange={e => handleChangeFile(e, 'electrical')} /> {t('worker.table.attachCertificate')}
                                    </UploadButton>
                                    <span>{form.fileName.split(/[/\\]/).pop()}</span>
                                    {errors?.fileName?.error && (
                                        <FormHelperText style={{ marginLeft: '12px' }} error={true}>{errors.fileName.error}</FormHelperText>
                                    )}
                                </ContainerUpload>
                            </ContainerCertificates>
                        </ContainerElectricalTechnicianFields>
                    </ContainerElectricalTechnician>
                }

                <ContainerGroup>
                    <ContainerChecks>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <CustomCheckbox
                                    onChange={(e) => handleChange(e, 'authorizationPersonalData', 'check')}
                                    required={errors?.authorizationPersonalData.error}
                                    checked={form.authorizationPersonalData}
                                />
                                <Link
                                    href='https://www.buds.com.ua/images/Lorem_ipsum.pdf'
                                    target='_blank'
                                    sx={{
                                        // cursor: 'pointer',
                                        textDecoration: 'underline',
                                        textDecorationColor: 'black'
                                    }}
                                    rel='noopener noreferrer'
                                >
                                    <Label sx={{ fontWeight: 'normal', cursor: 'pointer', fontSize: {xs: 12, md: 14} }}>
                                        {t('worker.authorizationPersonalData')}
                                    </Label>
                                </Link>
                            </div>
                            {errors?.authorizationPersonalData?.error && (
                                <FormHelperText style={{ marginLeft: '12px', marginTop: 0 }} error={true}>{errors.authorizationPersonalData.error}</FormHelperText>
                            )}
                    </ContainerChecks>
                </ContainerGroup>

            </ContainerContent>
        </ContainerBox >
    )
}